// extracted by mini-css-extract-plugin
export default {"summary":"InsightVI_summary__YeM9c","summary__title":"InsightVI_summary__title__bdJ+l","summary__metrics":"InsightVI_summary__metrics__PaFnA"};